<h2 mat-dialog-title>{{ data.title | translate: data.titleParams }}</h2>
<mat-dialog-content id="dialog-content"
  >{{ data.content | translate: data.contentParams }}
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (data.closeLabel) {
    <button mat-button type="button" [mat-dialog-close]="false">
      {{ data.closeLabel | translate }}
    </button>
  }
  @if (data.okLabel) {
    <button mat-button type="button" [mat-dialog-close]="true">
      {{ data.okLabel | translate }}
    </button>
  }
</mat-dialog-actions>
